// ============================================================================
// useReconciliation — Personal Finance V2 (Blueprint §6.2 / Fase 5)
// Hook que executa diffWithBling + healthScore sob demanda.
// ============================================================================

import { useMemo, useState, useCallback } from 'react';
import { diffWithBling, healthScore } from '../services/reconcileService.js';

/**
 * @param {object[]} postings       — postings Firestore do mês corrente
 * @param {object}   blingSnapshot  — recta_bling_snapshot.json (do useRectaBlingSnapshot)
 * @param {string}   yearMonth      — 'YYYY-MM'
 * @returns {{ result, health, run, hasRun }}
 */
export function useReconciliation(postings, blingSnapshot, yearMonth) {
    const [result, setResult] = useState(null);
    const [hasRun, setHasRun] = useState(false);

    const health = useMemo(() => healthScore(postings), [postings]);

    const run = useCallback(() => {
        if (!blingSnapshot || !postings.length) {
            setResult({ divergences: [], summary: { divergences: 0 }, blingMeta: null });
            setHasRun(true);
            return;
        }
        const r = diffWithBling(postings, blingSnapshot, yearMonth);
        setResult(r);
        setHasRun(true);
    }, [postings, blingSnapshot, yearMonth]);

    return { result, health, run, hasRun };
}
